import { render, staticRenderFns } from "./FloatIcon.vue?vue&type=template&id=36b002a9&scoped=true&"
import script from "./FloatIcon.vue?vue&type=script&lang=js&"
export * from "./FloatIcon.vue?vue&type=script&lang=js&"
import style0 from "./FloatIcon.vue?vue&type=style&index=0&id=36b002a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b002a9",
  null
  
)

export default component.exports